import { z } from 'zod';
import { randomNumber } from '../../utils';
import { inheritSchema } from '../IInherit';
import { ILegalClient, legalClientSchema } from '../ILegalClient';
import { mortgageSchema } from '../IMortgage';

export const shareSchema = z.object({
  Deposit: z.number(),
  Shares: z.number(),
  isPartPayment: z.boolean(),
  isShareByNonCashResources: z.boolean(),
  idRole_Representative: z.number(),
  Role_Representative: z.string(),
});

export type IShare = z.infer<typeof shareSchema>;

export const dataSchema = z.object({});

export const legalClientRelationshipMemberSchema = z.object({
  idLegalClient: z.number(),
  idRelationshipRole: z.number(),
  RelationshipRole: z.string(),
  Share: shareSchema.optional(),
  idLegalClientRelationship: z.number(),
  idRelationship: z.number(),
  // Needed to prevent circular dependency
  LegalClient: z.lazy(() => legalClientSchema),
});

export const legalClientRelationshipSchema = z.object({
  idRelationship: z.number(),
  idRelationshipType: z.number(),
  RelationshipType: z.string(),
  idLegalTransaction: z.number().optional(),
  Startdate: z.string().optional(),
  Enddate: z.string().optional(),
  idReference: z.number().optional(),
  hasTestament: z.boolean().optional(),
  Members: z.array(legalClientRelationshipMemberSchema).min(1),
  Mortgage: mortgageSchema.optional(),
  Inherit: inheritSchema.optional(),
  data: dataSchema.nullable().optional(),
  isActiveRelationship: z.boolean().optional(),
  isCompanyFormation: z.boolean().optional(),
  syncWithArnoTop: z.boolean().optional(),
});

export type ILegalClientRelationshipMember = z.infer<
  typeof legalClientRelationshipMemberSchema
>;

export type ILegalClientRelationship = z.infer<
  typeof legalClientRelationshipSchema
>;

export const issueMembers = (
  legalClients: ILegalClient[],
  relationshipRoleId: number,
  relationshipRole: string
): ILegalClientRelationshipMember[] =>
  legalClients.map(lc => ({
    idLegalClient: lc.idLegalClient,
    idRelationshipRole: relationshipRoleId,
    RelationshipRole: relationshipRole,
    LegalClient: lc,
    idLegalClientRelationship: -1,
    idRelationship: -1,
  }));

export const initLegalClientRelationship = (
  requiredMember: ILegalClient,
  relationshipTypeId: number,
  relationshipType: string,
  relationshipRoleId: number,
  relationshipRole: string
): ILegalClientRelationship => ({
  idRelationship: randomNumber() * -1,
  idRelationshipType: relationshipTypeId,
  RelationshipType: relationshipType,
  Members: issueMembers([requiredMember], relationshipRoleId, relationshipRole),
});
